export default "__VITE_ASSET__BmfylLlK__"